import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { AdminProgressReviewListItem } from '../../contracts/review'

export const getAdminProgressReviewListItem = asBuilder((): AdminProgressReviewListItem => {
  return {
    id: faker.number.int(),
    reviewId: faker.number.int(),
    postedAtUtc: faker.date.recent().toISOString(),
    progressDateUtc: faker.date.recent().toISOString(),
    durationOfDays: faker.number.int(),
    exposureStatus: faker.helpers.arrayElement(['APPROVED', 'DELETED']),
    authorId: 0,
    authorCountry: 'KR',
    authorNickname: faker.person.fullName(),
    photos: faker.helpers.multiple(() => ({
      url: faker.image.url(),
      blurred: faker.datatype.boolean(),
    })),
    ratings: faker.helpers.multiple(() => ({
      questionnaireId: faker.number.int(),
      content: faker.lorem.sentence(),
      score: faker.number.int(),
    })),
  }
})
